module.exports = __webpack_public_path__ + "static/media/porductos_altena__altaproteina.6186b51a.jpg";